import { Tabs } from 'antd';
import { QuestionnaireConfig } from 'data/questionnaire-config-type';
import { ImpactInventory } from 'features/patient/assessment/questionnaires/impact/impactAPISlice';
import { CgsInventory } from 'features/patient/assessment/questionnaires/cgs/cgsSlice';
import { DhiInventory } from 'features/patient/assessment/questionnaires/dhi/dhiSlice';
import { PcsInventory } from 'features/patient/assessment/questionnaires/pcs/pcsSlice';
import { PromisInventory } from 'features/patient/assessment/questionnaires/promis/promisSlice';
import { Inventory } from 'lib/documents';
import { Moment } from 'moment';
import { useState } from 'react';
import {
  CgsQuestionnaire,
  DhiQuestionnaire,
  PcsQuestionnaire,
  PromisQuestionnaire
} from '../../../../patient/_utils/questionnaires';
import { InventoryTab } from './inventory-tab';
import { InventoryTableDisplayProps } from './inventory-table-display/types';

export interface Assessment {
  date: Moment;
  cgs: CgsInventory;
  pcs: PcsInventory;
  dhi: DhiInventory;
  promis: PromisInventory;
  impact: ImpactInventory;
}

type AssessmentBreakdownProps = {
  assessment: Assessment;
} & Pick<InventoryTableDisplayProps, 'inventoryFilterConfig'>;

const TAB_CONFIG: Record<
  string,
  {
    inventory: (props: AssessmentBreakdownProps) => Inventory;
    config: QuestionnaireConfig;
  }
> = {
  cgs: {
    inventory: (props: AssessmentBreakdownProps) => props.assessment.cgs,
    config: CgsQuestionnaire
  },
  dhi: {
    inventory: (props: AssessmentBreakdownProps) => props.assessment.dhi,
    config: DhiQuestionnaire
  },
  pcs: {
    inventory: props => props.assessment.pcs,
    config: PcsQuestionnaire
  },
  promis: {
    inventory: props => props.assessment.promis,
    config: PromisQuestionnaire
  }
};
const items = [
  {
    key: 'cgs',
    label: 'CGS'
  },
  {
    key: 'dhi',
    label: 'DHI'
  },
  {
    key: 'pcs',
    label: 'PCS'
  },
  {
    key: 'promis',
    label: 'Promis'
  }
];
export function AssessmentBreakdown(props: AssessmentBreakdownProps) {
  /**
   * We control the active key because we want to ensure that the current tab is the only component that renders.
   * If we use the `children` key in the `items` array, each tab and table will render every time `inventoryFilterConfig` changes.
   */
  const [activeKey, setActiveKey] = useState('cgs');

  const tabConfig = TAB_CONFIG[activeKey];
  if (tabConfig === undefined) {
    throw new Error(
      `[AssessmentBreakdown] Tab key '${activeKey}' was not found.`
    );
  }
  return (
    <div>
      <Tabs
        activeKey={activeKey}
        onChange={activeKey => setActiveKey(activeKey)}
        items={items}
      />

      {/* Only render the tab that is currently being previewed */}
      <InventoryTab
        inventory={tabConfig.inventory(props)}
        config={tabConfig.config}
        inventoryFilterConfig={props.inventoryFilterConfig}
      />
    </div>
  );
}
